import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import * as axiosConfiguration from "../../configuration/axios-configuration/axios.token-configuration";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "../../i18n/useTranslation";
import { redirectToLanguageHome } from "../../shared/services/language.service";
import { PROCUREMENT_LOGIN } from "../../shared/constants/breadcrumb.constants";

export interface IProcurementLogin {
    loginUrl: string;
}

const ProcurementLogin: React.FC<IProcurementLogin> = ({loginUrl}) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const { t } = useTranslation('translation');
    const { language } = useParams();

    useEffect(() => {
        const login = async () => {
            try {
                const username = searchParams.get("username");
                const password = searchParams.get("password");
                const hookUrl = searchParams.get("HOOK_URL");

                const isPlenionLogin =
                    loginUrl === PROCUREMENT_LOGIN.PLENION;

                if (
                    !username ||
                    !password ||
                    (!isPlenionLogin && !hookUrl)
                ) {
                    setErrorMessage(
                        t("procurement.loginUnexpectedError")
                    );
                    return;
                }

                localStorage.removeItem("token");

                const response = await axios.get(
                    language
                        ? `${language}/${loginUrl}`
                        : loginUrl,
                    {
                        params: {
                            username,
                            password,
                            ...(isPlenionLogin
                                ? {}
                                : { HOOK_URL: hookUrl })
                        }
                    }
                );
                if (response?.data?.token) {
                    localStorage.setItem(
                        "token",
                        response.data.token);

                    sessionStorage.setItem(
                        "procurementHookUrl",
                        response.data.hookUrl);
                        
                    axiosConfiguration.setAuthToken();

                    redirectToLanguageHome(response.data.language);

                    navigate("/");
                } else {
                    setErrorMessage(
                        t("procurement.loginUnexpectedError")
                    );
                }

            }
            catch {
                setErrorMessage(
                    t("procurement.loginUnexpectedError")
                );
            }
        };

        login();
    }, [navigate, searchParams]);
    if (errorMessage) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
                mt={8}
            >
                <Alert severity="error">
                    {t(errorMessage)}
                </Alert>
            </Box>
        );
    }
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
            mt={8}
        >
            <CircularProgress size={20} />

            <Typography color="text.secondary">
                {t("procurement.connectingSession")}
            </Typography>
        </Box>
    );
};

export default ProcurementLogin;